import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static values = { createUrl: String }

  toggle(event) {
    const checkbox = event.target
    const item = checkbox.closest("[data-stock-alert-target='item']")

    if (checkbox.checked) {
      this.create(checkbox, item)
    } else {
      this.destroy(checkbox, item)
    }
  }

  async create(checkbox, item) {
    const variantId = item.dataset.variantId
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    checkbox.disabled = true

    try {
      const response = await fetch(this.createUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: `variant_id=${variantId}`
      })

      if (response.ok) {
        const data = await response.json()
        item.dataset.alertId = data.id
        checkbox.dataset.stockAlertDestroyUrlParam = `${this.createUrlValue}/${data.id}`
        item.classList.remove("opacity-50")
      } else {
        checkbox.checked = false
      }
    } catch {
      checkbox.checked = false
    } finally {
      checkbox.disabled = false
    }
  }

  async destroy(checkbox, item) {
    const destroyUrl = checkbox.dataset.stockAlertDestroyUrlParam
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    try {
      const response = await fetch(destroyUrl, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        }
      })

      if (!response.ok) {
        checkbox.checked = true
      } else {
        item.classList.add("opacity-50")
      }
    } catch {
      checkbox.checked = true
    }
  }
}
